// extracted by mini-css-extract-plugin
export var button = "_mg-0";